<template>
    <div class="loop-item blog-item">
        <router-link :to="$i18nRoute({name: 'blog-individual', params: {page: item.slug}})">
            <div class="item-image">
                <img :src="item.thumbnail" alt />
            </div>
            <h3 class="post-title">{{item.title}}</h3>
            <p class="post-excerpt">{{item.excerpt}}</p>
            <p class="post-date">{{item.last_update}}</p>
            <div class="item-price" v-html="item.price_html"></div>
        </router-link>
    </div>
</template>

<script>
export default {
    props: ['item'],
    data () {
      return {}
    }
}
</script>

<style lang="scss">
    .blog-item{
        .item-image{
            &:before{
                padding-top: 70%;
            }
        }
        .post-title{
            margin-top: 15px;
            font-family: $font-bold;
            font-size: 20px;
        }
        .post-excerpt{
            font-size: 16px;
            margin-top: 10px;
        }
        .post-date{
            font-family: $font-bold;
            font-size: 16px;
            margin-bottom: 0;
        }
    }
</style>
